<div class="no-content" *ngIf="notifications.length==0">
  {{noNotificationFoundLabel}}
</div>

<div class="scroll-container" *ngIf="notifications.length > 0"> <!-- -->
  <div class="notification-card " *ngFor="let notification of notifications">
    <div class="col-12 notification-time grid">
      <div class="col-6 date ">
        {{notification.createdAt| dateformat}}
      </div>
      <div class="col-6 ago ">
        {{notification.createdAt| ago }}
      </div>

      <div class="col-12 message">
        {{notification.message}}
      </div>
    </div>
  </div>

  <div class="col-12" *ngIf="notifications.length > 0">
    <button pButton appRipple class="assign-btn load-more-btn" type="button" [label]="labelLoadMore" (click)="onLoadMore()"></button>
  </div>

</div>

<div *ngIf="notifications.length === 0">
  <div class="lg:col-12 no no-records" translate>
    label_no_notification_list
  </div><!-- label_no_notification_found-->
</div>
